import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {urlParams} from 'utils/request';
import useStarfishAPI from '../hooks/useStarfishAPI';
import TextHeader from "./TextHeader";
import css from "./ReasonSelection.css";
import useError from "../hooks/useError";
import RadioCardOption from './RadioCardOption'
import {getGroupSessionByReasonId, isSelfService} from "../utils/kiosk";
import {Card} from "semantic-ui-react";
import ContinueButton from "./ContinueButton";
import SubmitStudentAPI from "./SubmitStudentAPI";

function ReasonSelection(props) {

  props.setWarning(null);
  const [{data: reasonData, success: reasonSuccess, error: reasonError, pending: reasonsPending}, callKioskForReasons] = useStarfishAPI();
  const [{data: groupSessionData, error: groupSessionsSuccessError}, callKioskForGroupsSessions] = useStarfishAPI();
  const [{success: submitStudentSuccess, error: submitStudentError}, {onSubmitProspectApi, onSubmitStudentApi}] = SubmitStudentAPI(props.setWaitingRoomQueueId);
  const [reason, setReason] = useState(props.reason);
  useError(reasonError, props.setError);
  useError(groupSessionsSuccessError, props.setError);
  useError(submitStudentError, props.setError);

  if (submitStudentSuccess) {
    props.goToConfirmationPage();
  }

  const isGroupSessionAvailable = (reasonItem) => !!getGroupSessionByReasonId(groupSessionData, reasonItem.id);

  const getReasons = () => {
    const params = urlParams({serviceId: props.serviceId}, false);
    const URL = `../kiosk/getReasonsForKiosk.html?${params}`;
    return callKioskForReasons(URL, {
      method: 'GET',
    });
  };

  const getGroupSessions = () => {
    const params = urlParams({serviceId: props.serviceId, studentId: props.studentId}, false);
    const URL = `../kiosk/getGroupSessionForKiosk.html?${params}`;
    return callKioskForGroupsSessions(URL, {
      method: 'GET',
    });
  };

  const selectReason = () => {
    if (props.isProspectiveStudent && !props.showMoreInformationPage) {
      const params = JSON.stringify({
        kioskId: props.kioskId,
        studentId: props.studentId,
        serviceId: props.serviceId,
        reasonId: reason.id,
        prospectWalkin: props.isProspectiveStudent,
        secondaryEmail: props.email,
      });
      onSubmitProspectApi(params);
      return;
    }

    if (props.shouldSkipCourseAndMoreInformationPages && !isGroupSessionAvailable(reason)) {
      const params = urlParams({
        studentId: props.studentId,
        serviceId: props.serviceId,
        reasonId: reason.id,
        kioskId: props.kioskId
      }, false);
      onSubmitStudentApi(params);
      return;
    }
    props.selectReason(reason);
  };

  useEffect(() => {
    getReasons();
    // Neither prospective students nor any student in a self-service kiosk can sign up for group sessions
    if (!props.isProspectiveStudent && !isSelfService(props.kioskType)) getGroupSessions();
  }, [props.serviceId, props.studentId, props.kioskType]);

  const getReasonsCardOptions = () => {
    return (
        <div>
          <Card.Group role="radiogroup" aria-labelledby="reasonSelection">
            {reasonData.result.map(reasonItem => {
              return (
                  <RadioCardOption
                      key={reasonItem.id}
                      label={reasonItem.name}
                      radioGroupName={'reasonGroup'}
                      description={isGroupSessionAvailable(reasonItem) ? 'Group sessions available' : null}
                      icon={'group'}
                      onSelect={() => {
                        setReason({...reasonItem, groupSessionAvailable: isGroupSessionAvailable(reasonItem)});
                      }}
                      isChecked={!!reason && reasonItem.id === reason.id}
                  />
              );
            })}
          </Card.Group>
          <ContinueButton onClick={selectReason} disabled={!reason.id}/>
        </div>
    );
  };

  if (reasonsPending) {
    return <div aria-label='Loading reasons...'>Loading reasons...</div>;
  } else if (!reasonSuccess) {
    return <div>Unable to fetch reasons</div>;
  }

  return (
      <div>
        <div className={css['content']}>
          <div className={css['header']}>
            <TextHeader id="reasonSelection" upperText={props.greetingText} lowerText={props.mainHeader} />
          </div>
          {getReasonsCardOptions()}
        </div>
      </div>
  );

}

ReasonSelection.propTypes = {
  serviceId: PropTypes.number.isRequired,
  studentId: PropTypes.number,
  reason: PropTypes.object,
  isProspectiveStudent: PropTypes.bool.isRequired,
  setWaitingRoomQueueId: PropTypes.func.isRequired,
  selectReason: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
  kioskType: PropTypes.string.isRequired,
  setWarning: PropTypes.func.isRequired,
  showMoreInformationPage: PropTypes.bool.isRequired,
  email: PropTypes.string,
  kioskId: PropTypes.number.isRequired,
  goToConfirmationPage: PropTypes.func.isRequired,
  greetingText: PropTypes.string,
  mainHeader: PropTypes.string,
  shouldSkipCourseAndMoreInformationPages: PropTypes.bool.isRequired
};

export default ReasonSelection;
